import React, { useState } from 'react'
import './style.scss'
import Icon from 'react-icons-kit'
import { Link } from 'react-router-dom'
import Requests from '../../utils/Requests/Index'
import { DateSpliter } from '../../utils/helpers'
import DeleteComponent from '../modal/delete/Index'
import {  edit2, trash } from 'react-icons-kit/feather'

const AppointmentBooking = ({ items, refetch }) => {
    const [isDelete, setDelete] = useState({ value: null, show: false, loading: false })
    const [header] = useState({
        headers: { Authorization: "Bearer " + localStorage.getItem('token') }
    })
// console.log(items);

    const handleDelete = async id => {
        setDelete({ ...isDelete, loading: true })
        await Requests.AppointmentBooking.Delete(id, header)
        refetch()
        setDelete({ value: null, status: null, loading: null })
    }

    return (
        <div className="content-image-table-container pb-4">
            <table className="table table-hover table-responsive-sm table-borderless">
                <thead>
                    <tr className="border-bottom">
                        <td className="text-center sl-td">SL</td>
                        <td className="text-center sl-td">Date</td>
                        <td>Name</td>
                        <td>Phone</td>
                        <td>Medium Of Advice</td>
                        <td>Expert Counselor</td>
                        <td>Package</td>
                        <td>Accept</td>
                        <td className="text-td text-center">Action</td>
                    </tr>
                </thead>
                <tbody>
                    {items && items.length ?
                        items.map((item, i) =>
                            <tr className="border-bottom" key={i}>
                                <td className="text-center sl-td">{i + 1}</td>
                                <td className="text-td">{item.date ? DateSpliter(item.date) : 'N/A'}</td>
                                <td className="text-td">{item.name ? item.name : 'N/A'}</td>
                                <td className="text-td">{item.phone ? item.phone : 'N/A'}</td>
                                <td className="text-td">{item.mediumOfAdvice ? item.mediumOfAdvice : 'N/A'}</td>
                                <td className="text-td">
                                    <div className='flex justify-content-between align-items-center'>
                                        {item.expertCounselor.image ? (
                                        <img
                                        src={process.env.REACT_APP_IMAGE_URL+'/'+item.expertCounselor.image}
                                        alt={item.expertCounselor.name}
                                        className="img-fluid rounded-circle me-2"
                                        style={{ width: 45, height: 45, objectFit: 'cover' }}
                                        />
                                    ) : (
                                        <div
                                        className="rounded-circle bg-secondary me-2"
                                        style={{ width: 45, height: 45 }}
                                        />
                                    )}
                                        {item.expertCounselor ? <p className="text-capitalize mb-0">{item.expertCounselor.name}</p> : 'N/A'}
                                    </div>
                                </td>
                                <td className="text-td">{item.package ? item.package : 'N/A'}</td>
                                <td className="text-td">{item.accept}</td>
                                <td className="button-td text-center">
                                    {/* <Link
                                        type="button"
                                        to={`/dashboard/website/expert-counselors-profile/${item._id}/show`}
                                        className="btn btn-sm shadow-none table-show-btn"
                                    >
                                        <Icon icon={eye} size={20} />
                                    </Link> */}
                                    <Link
                                        type="button"
                                        to={`/dashboard/website/appointment-booking/${item._id}/edit`}
                                        className="btn btn-sm shadow-none table-edit-btn"
                                    >
                                        <Icon icon={edit2} size={20} />
                                    </Link>
                                    <button
                                        type="button"
                                        className="btn btn-sm shadow-none table-trash-btn"
                                        onClick={() => setDelete({ value: item, show: true, loading: false })}
                                    >
                                        <Icon icon={trash} size={20} />
                                    </button>
                                </td>
                            </tr>
                        ) : null}
                </tbody>
            </table>

            {/* Delete modal */}
            {isDelete.value && isDelete.show ?
                <DeleteComponent
                    title={'Blog'}
                    image={isDelete.value.image}
                    data={isDelete.value._id}
                    show={isDelete.show}
                    loading={isDelete.loading}
                    delete={handleDelete}
                    onHide={() => setDelete({ ...isDelete, value: null, status: false })}
                />
                : null}

        </div>
    )
};

export default AppointmentBooking;